import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
import { HStack, XButton, XDiv, XText, XVPScroll } from "IZOX/_X";
// eslint-disable-next-line no-unused-vars
import React, { CSSProperties, useEffect, useRef } from "react";
import _ from "lodash";
import { observer } from "mobx-react";

/**
 * @typedef {import("IZOX/__Typedef/common").lang} lang
 * @typedef {import("IZOX/_X/XInput").xinputparams} xinputparams
 * @typedef {import("IZOX/_X/XInput").xinputstyleparams} xinputstyleparams
 * @typedef {import("IZOX/_X/XButton").xbuttonparams} xbuttonparams
 * @typedef {import("IZOX/_X/XText").xtextparams} xtextparams
 * @typedef {import("IZOX/STATIC/ZValidate").fvalidate} fvalidate
 * 
 * @typedef {Object} qfselectoptions
 * @property {lang} cap
 * @property {String} val
 * @property {String} color
 * 
 * @typedef {Object} qfselecttabparams
 * @property {String} name
 * @property {lang} label
 * @property {any} defaultValue
 * @property {Function} _onChange
 * @property {Function} _onSetDefault
 * @property {any} formValue
 * @property {qfselectoptions[]} options
 * @property {String} invalidColor
 * @property {String} capAccessor
 * @property {String} valAccessor
 * @property {xbuttonparams} unselectedBtnProps
 * @property {xbuttonparams} selectedBtnProps
 * @property {xtextparams} selectedTextProps
 * @property {xtextparams} unselectedTextProps
 * @property {Number} spacing
 * @property {Boolean} mulitple
 * @property {"H" | "V"} direction
 * 
 * @typedef {xinputparams & xinputstyleparams & qfselecttabparams} qftabradioparams
 * 
 * @param {qftabradioparams} param0
 * @returns 
 */
function QFTabRadio({
  name = undefined,
  label = undefined,
  _onChange = null,
  _onSetDefault = null,
  defaultValue = undefined,
  formValue = {},
  options = [],
  invalidColor = ColorX.CSS("pureRed"),
  renderOption = undefined,
  listMaxHeight = 300,
  listFontSize = 14,
  popupPosition = "bottom",
  iconSize = undefined,
  allowSearch = false,
  searchComparer = null,
  capAccessor = "cap",
  valAccessor = "val",
  selectedBtnProps = {},
  unselectedBtnProps = {},
  selectedTextProps = {},
  unselectedTextProps = {},
  spacing = 5,
  multiple = false,
  updateVia = undefined, 
  updateField = undefined,
  forceUpdateField = undefined,
  performanceBoost = undefined,
  direction = "H",
  ...others
}){

  const ref = useRef(null);

  useEffect(() => {
    if(defaultValue) {
      _onSetDefault?.(name, defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, options]);

  let {readOnly} = others;

  // const onInputChange = (name, text) => {
  //   setDisplay(text);
  // };

  const onListConfirm = (value) => {
    if(readOnly) return;

    if(multiple){
      let _value = Accessor.Get(formValue, name) ?? [];
      let newValue = _value;
      
      if(_value.includes(value)){
        newValue = _.filter(_value, o => o !== value); 
      }else{
        newValue.push(value);
      }
      _onChange(name, newValue);

    }else{

      _onChange(name, value);
    }

  };

  const renderTab = (option, idx) => {
    let _value = Accessor.Get(formValue, name) ?? [];
    let oValue = Accessor.Get(option, valAccessor);
    let isSelected = multiple ? _value.includes(oValue) 
      : _value === oValue;
    let cap = Accessor.Get(option, capAccessor);
    let val = Accessor.Get(option, valAccessor);
    return (
      <XButton {...(isSelected ? selectedBtnProps : unselectedBtnProps)}
        onPress={() => onListConfirm(val)} key={idx} lockHeight={30}>
        <HStack fitWidthToContent>
          <XText {...(isSelected ? selectedTextProps : unselectedTextProps)}>
            {LocaleX.Parse(cap)}
          </XText>
        </HStack>
      </XButton>
    );
  };

  const renderTabV = (option, idx) => {
    let _value = Accessor.Get(formValue, name) ?? [];
    let oValue = Accessor.Get(option, valAccessor);
    let isSelected = multiple ? _value.includes(oValue) 
      : _value === oValue;
    let cap = Accessor.Get(option, capAccessor);
    let val = Accessor.Get(option, valAccessor);
    return (
      <XButton {...(isSelected ? selectedBtnProps : unselectedBtnProps)}
        onPress={() => onListConfirm(val)} key={idx} flexShrink={0} mB={5}>
        <HStack fitWidthToContent>
          <XText {...(isSelected ? selectedTextProps : unselectedTextProps)}>
            {LocaleX.Parse(cap)}
          </XText>
        </HStack>
      </XButton>
    );
  };

  const renderTabs = () => {
    return _.map(options, (o, i) => {
      return renderTab(o, i);
    });
  };

  let {width, height} = others;

  if(direction === "H"){
    return (
      <XDiv width={width} height={height} position="relative" overflow="visible" forwardRef={ref}>
        <HStack spacing={spacing} fullWidth fullHeight flexWrap="wrap" HAlign="[">
          {renderTabs()}
        </HStack>
      </XDiv>
    );
  }else{
    // return (
    //   <VStack spacing={spacing} fullWidth fullHeight flexWrap="wrap" HAlign="[">
    //     {renderTabs()}
    //   </VStack>
    // );
    return (
      <XVPScroll fullWidth items={options}>
        {(o, i) => {
          return renderTabV(o, i);
        }}
      </XVPScroll>
    );
  }
  
}

export default observer(QFTabRadio);